import { createQuery, request } from '@luna/api';
import { getEnv } from '@luna/env';
import { deepClean } from '@luna/utils';
import { createQueryString } from '@luna/router';

import type { Account, PagedListResponse } from './types/aggregationService';

type RequestOptions = {
    cardId: string;
    search?: string;
};

export const [useCardRepaymentAccounts] = createQuery({
    name: '@accounts/card-repayment-accounts',
    cacheKey: ({ cardId, search = '' }) => cardId + search,
    payloadCreator: async ({ cardId, search }: RequestOptions) => {
        const query = createQueryString({
            cardId,
            ...deepClean({ search }),
        });

        const { apiGatewayUrl } = getEnv();
        const url = `${apiGatewayUrl}product/public/accounts/card-repayment-accounts${query}`;
        const response = await request<PagedListResponse<Account>>(url);

        return response.items;
    },
});
